<template>
	<div class="contact-wrap">
		<div class="banner">
			<img src="../assets/img/banner5.png" />
		</div>
		<div class="content">
			<div class="item">
				<p class="title">联络地址</p>
				<p class="text">星华租赁（山东）有限公司</p>
				<p class="text">地址：山东省青岛市市南区金湖路街道山东路9号B号楼6F户018</p>
			</div>
			<div id="map"></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	mounted() {
		var map = new BMap.Map("map");  // 创建Map实例

		var myGeo = new BMap.Geocoder();
		// 将地址解析结果显示在地图上,并调整地图视野
		myGeo.getPoint("山东省青岛市市南区金湖路街道山东路9号B号楼6F户018", function (point) {
			if (point) {
				map.centerAndZoom(point, 17);
				map.enableScrollWheelZoom(true);
				var marker = new BMap.Marker(point);  // 创建标注
				map.addOverlay(marker);              // 将标注添加到地图中
				var label = new BMap.Label("星华租赁（山东）有限公司", { offset: new BMap.Size(25, 0) });
				marker.setLabel(label)
			} else {
				alert("您选择地址没有解析到结果!");
			}
		}, "青岛市");
	}
}

</script>

<style lang="scss" scoped>
.contact-wrap {
	background:#fff;
	.banner {
		img {
			display: block;
			width: 100%;
		}
	}

	.content {
		width: 1200px;
		margin: 0 auto;
		padding: 100px 0 160px;
		.item {
			.title{
				letter-spacing: 1px;
				color: #0f5eb7;
				font-size:24px;
				line-height:26px;
				font-weight: bold;
				margin-bottom:26px;
			}
			.text {
				font-size: 16px;
				line-height: 26px;
				color: #666666;
			}
		}
		#map {
			width: 100%;
			height: 450px;
			margin-top:44px;
		}
	}
}
</style>